import { styled } from '@mui/styles';
import StepConnector from '@mui/material/StepConnector';
import { stepConnectorClasses, StepContent, StepLabel, Container, Paper } from '@mui/material';

export const ResponsiveStepperConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#01BFA5',
      borderLeftStyle: 'dashed',
      borderWidth: 2,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#01BFA5',
      borderLeftStyle: 'dashed',
      borderWidth: 2,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export const StyledStepContent = styled(StepContent)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    borderLeft: 0,
    marginLeft: 0,
    padding: '0 32px',
  },
}));

export const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const StyledContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  maxWidth: 970,
  marginBottom: 40,
  paddingLeft: 24,
  paddingRight: 24,

  [theme.breakpoints.down('sm')]: {
    marginTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: 24,
  minHeight: 240,
  backgroundColor: theme.vars.palette.bigid?.white,
  boxShadow: theme.vars.tokens?.bigid?.shadow10,

  [theme.breakpoints.down('sm')]: {
    padding: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
}));
